<template>
  <div class="prescription-container">
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    
    <v-card class="mb-5" outlined>
      <v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="2" class="mb-1">
              <div class="text-h6">Prescription</div>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                  :items="doctors"
                  item-text="dr_name"
                  item-value="id"
                  label="Doctor List"
                  v-on:change="getReports()"
                  v-model="searchParamDoctorId"
                  :loading="isLoading"
                  outlined
                  dense
                  hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="date"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </template>

                <v-date-picker
                    v-model="date"
                    @input="menu2 = false"
                    @click:date="dateSelect"
                    :max="nowDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                  outlined
                  dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-row align="center" justify="center">
                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          depressed
                          v-on="on"
                          class="ms-2"
                          color="primary"
                          v-on:click="printList"
                      >
                        <v-icon>mdi-printer</v-icon>
                      </v-btn>
                    </template>
                    <span>Lens advice prescription print</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>

    <v-card outlined>
      <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-0"
          :search="search"
          dense
          mobile-breakpoint="0"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="_edit(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon>mdi-pencil-box</v-icon>
              </v-chip>
            </template>
            <span>Edit Prescription</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="_print('prescription',item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="success"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-eye </v-icon>
              </v-chip>
            </template>
            <span>View / Print Prescription</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="_print('lens_prescription', item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon>mdi-hololens </v-icon>
              </v-chip>
            </template>
            <span>View / Print Lens Prescription</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getReports">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import atshq from "../../../js/setup";
import moment from "moment";

export default {
  name: "PrescriptionList",
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      nowDate: moment().format('YYYY-MM-DD'),
      menu2: false,
      loadingstatus: true,
      isLoading: true,
      returnUrl: atshq.defaults.headers.common.app_URL,
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
      search: "",
      doctors: [],
      searchParamDoctorId: '',
      headers: [
        { text: "ID", value: "id" },
        { text: "Patient ID", value: "patient_id" },
        {
          text: "Patient Name",
          value: "patient.patient_name",
        },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Internal Referred From", value: "internal_referred_doctor.dr_name" },
        { text: "Prescription Date", value: "prescription_date" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Prescriptions",
          disabled: true,
          href: "Prescriptions",
        },
      ],
    };
  },
  created() {
    this.getReports();
    this.getDoctors();
  },
  methods: {
    getReports() {
      atshq
          .get("prescriptions/list?date=" + this.date + "&doctor=" + this.searchParamDoctorId)
          .then((response) => {
            this.loadingstatus = false;
            this.desserts = response.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getDoctors() {
      atshq
          .get("doctors?status=1")
          .then((response) => {
            this.doctors = response.data.data;
            this.loadingstatus = false;
            this.isLoading = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },
    _print(type, item) {
      if(type === 'prescription') {
        window.open(
            this.returnApiBaseURL + "print/doctor-prescription/" + item.patient_id + "/" + item.id
        );
      } else if (type === 'lens_prescription') {
        window.open(
            this.returnApiBaseURL + "print/lens-prescription/" + item.patient_id + "/" + item.id
        );
      }
    },
    _edit(item) {
      window.open(
          this.returnUrl + "prescription/treatment/edit/" + item.patient_id + "/" + item.id
      );
    },
    dateSelect() {
      this.loadingstatus = true;
      this.getReports();
    },
    printList(){
      window.open(this.returnApiBaseURL + "print/lens-prescription-list?doctor_id=" + this.searchParamDoctorId + '&date=' + this.date + '');
    }
  },
};
</script>

<style scoped>
.prescription-container {
  padding: 16px;
  background-color: whitesmoke;
  min-height: calc(100vh - 64px);
}

.v-card {
  border-radius: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
}

.mb-5 {
  margin-bottom: 20px;
}

.v-chip {
  cursor: pointer;
}

.v-chip:hover {
  opacity: 0.8;
}
</style>
